<template>
  <b-container class="main-content details-page" >
    <h1>{{ this.pageTitle }}</h1>
    <div class="d-flex align-items-center" v-if="loading">
      <strong>Lade Daten...</strong>
      <b-spinner type="grow" label="Loading..." class="loader ml-auto"></b-spinner>
    </div>
    <div class="liste" v-else>
      <b-card class="listitem" v-for="proposal in proposals" :key="proposal.id">
        <b-card-text>
          <b-row align-v="center">
            <b-col cols="12" lg="auto" class="mb-2 mb-lg-0">
              <b>{{proposal.effectiveDate}}</b>
            </b-col>
            <b-col class="mb-4 mb-lg-0">
              {{proposal.name}}
            </b-col>
            <b-col cols="12" lg="6" xl="5">
              <b-row>
                <b-col cols="6" sm="4" class="mb-4 mb-sm-0">
                  <router-link class="btn btn-primary btn-block" role="button" :class="type == 'archiv' ? 'disabled' : ''" block :to="{name: 'code', params: {id: proposal.id}}">
                    <icon icon="vote-yea" /><br>Abstimmen
                  </router-link>
                </b-col>
                <b-col cols="6" sm="4" class="mb-4 mb-sm-0">
                  <router-link class="btn btn-primary btn-block" role="button" :to="{name: 'proposalDetails', params: {id: proposal.id}}">
                    <icon icon="info-circle" /><br>Details
                  </router-link>
                </b-col>
                <b-col cols="12" sm="4">
                  <router-link class="btn btn-primary btn-block" role="button"  :class="type == 'liste' ? 'disabled' : ''" :to="{name: 'ergebnisse', params: {id: proposal.id}}">
                    <icon icon="poll-h" /><br>Ergebnisse
                  </router-link>
                </b-col>
              </b-row>
            </b-col>
          </b-row>
        </b-card-text>
      </b-card>
      <div class="mx-auto-archiv">
        <router-link class="btn btn-primary btn-lg archiv" :to="{ name: 'liste', params: {type: this.link}}" title="ältere Abstimmungen">
          {{ this.linkName }}
        </router-link>
      </div>
    </div>
    <b-alert show variant="danger" v-if="error">Fehler beim laden!</b-alert>
  </b-container>
</template>

<script>
import client from 'api-client';

export default {
  name: 'Liste',
  props: ['id', 'type'],
  data() {
    return {
      loading: true,
      proposals: {},
      error: false,

    };
  },
  computed: {
    pageTitle() {
      return this.type === 'liste' ? 'Aktuelle Abstimmungen' : 'Archiv';
    },
    link() {
      return this.type === 'liste' ? 'archiv' : 'liste';
    },
    linkName() {
      return this.type === 'liste' ? 'Archiv' : 'Liste';
    },
  },
  created() {
    this.loadProposals();
  },
  watch: {
    $route(to, from) {
      this.loading = true;
      this.loadProposals();
    },
  },
  methods: {
    loadProposals() {
      client
        .fetchProposalList(this.type === 'archiv')
        .then(proposals => this.setProposals(proposals))
        .catch((e) => {
          console.error(e);
          this.error = true;
        });
    },
    setProposals(proposals) {
      this.proposals = proposals;
      this.loading = false;
    },
  },
};

</script>

<style scoped>
.mx-auto-archiv {
  margin-top: 40px;
}
.proposal-link{
  margin: 10px;
}
.proposal-title {
  margin: 10px;
  flex-basis: 0;
  flex-grow: 1;
  max-width: 100%;
}
.proposal-date {
  padding-top: 10px;
  padding-bottom: 10px;
  font-weight: bold;
  font-size: 110%;
}
.listitem {
  background-color: #fff7f7;
  margin: 3px;
  padding-left: 10px;
}
</style>
